
import { Amplify } from 'aws-amplify';
import { DataStore } from 'aws-amplify/datastore';
import awsconfig from './aws-exports';

let isConfigured = false;

export async function configureAmplifyAndStartDataStore() {
  if (isConfigured) {
    console.log('Amplify already configured.');
    return;
  }
  
  try {
    Amplify.configure(awsconfig);
    await DataStore.start();
    isConfigured = true;
    console.log('✅ Amplify configured and DataStore started');
  } catch (error) {
    console.error('❌ Error configuring Amplify or starting DataStore:', error);
  }
}

export default awsconfig;
